<template>
	<div class="projetolistagem">
		<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
		<div class="container">
			<ol class="breadcrumb-arrow">
				<li>
					<a href="/home"><i class="fa fa-home"></i></a>
					<a href="/portifolio">Portifólio</a>
				</li>
				<li class="active"><span>Meu portifólio</span></li>
			</ol>
		</div>

		<div class="container mt-2">
			<div class="container mt-2">
				<div class="card">
					<div class="card-body font-13 pt-2">

						<div class="row">
							<div class="col-6">

								<div class="row mb-2">
									<div class="col-4 mt-2 font-bold text-right">
										Projeto
									</div>
									<div class="col-8">
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text">
													<i class="far fa-calendar-alt"></i>
												</span>
											</div>
											<flat-picker
												tabindex="1"
												id="dataInicio"
												class="font-13 form-control datepicker"
												placeholder="Data Inicial"
												v-model="filtro.projetoDataInicio"
												:config="{
													allowInput: true,
													dateFormat: 'd/m/Y',
													altFormat: 'M j, Y',
												}"/>
											<span class="m-2">até</span>
											<div class="input-group-prepend">
												<span class="input-group-text"
												><i class="far fa-calendar-alt"></i
												></span>
											</div>
											<flat-picker
												tabindex="2"
												id="dataFim"
												class="font-13 form-control datepicker"
												placeholder="Data Final"
												v-model="filtro.projetoDataFim"
												:config="{
													allowInput: true,
													minDate: filtro.projetoDataInicio,
													dateFormat: 'd/m/Y',
													altFormat: 'M j, Y',
												}"/>
										</div>
									</div>
								</div>
								<div class="row mb-2">
									<div class="col-4 mt-2 font-bold text-right">
										Atividade
									</div>
									<div class="col-8">
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text">
													<i class="far fa-calendar-alt"></i>
												</span>
											</div>
											<flat-picker
												tabindex="1"
												id="dataInicio"
												class="font-13 form-control datepicker"
												placeholder="Data Inicial"
												v-model="filtro.projetoDataInicio"
												:config="{
													allowInput: true,
													dateFormat: 'd/m/Y',
													altFormat: 'M j, Y',
												}"/>
											<span class="m-2">até</span>
											<div class="input-group-prepend">
												<span class="input-group-text"
												><i class="far fa-calendar-alt"></i
												></span>
											</div>
											<flat-picker
												tabindex="2"
												id="dataFim"
												class="font-13 form-control datepicker"
												placeholder="Data Final"
												v-model="filtro.projetoDataFim"
												:config="{
													allowInput: true,
													minDate: filtro.projetoDataInicio,
													dateFormat: 'd/m/Y',
													altFormat: 'M j, Y',
												}"/>
										</div>
									</div>
								</div>
								<div class="row mb-2">
									<div class="col-4 mt-2 font-bold text-right">
										Tarefa
									</div>
									<div class="col-8">
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text">
													<i class="far fa-calendar-alt"></i>
												</span>
											</div>
											<flat-picker
												tabindex="1"
												id="dataInicio"
												class="font-13 form-control datepicker"
												placeholder="Data Inicial"
												v-model="filtro.projetoDataInicio"
												:config="{
													allowInput: true,
													dateFormat: 'd/m/Y',
													altFormat: 'M j, Y',
												}"/>
											<span class="m-2">até</span>
											<div class="input-group-prepend">
												<span class="input-group-text"
												><i class="far fa-calendar-alt"></i
												></span>
											</div>
											<flat-picker
												tabindex="2"
												id="dataFim"
												class="font-13 form-control datepicker"
												placeholder="Data Final"
												v-model="filtro.projetoDataFim"
												:config="{
													allowInput: true,
													minDate: filtro.projetoDataInicio,
													dateFormat: 'd/m/Y',
													altFormat: 'M j, Y',
												}"/>
										</div>
									</div>
								</div>

							</div>
							<div class="col-6 d-flex align-items-center justify-content-center">
								<button
									type="button"
									class="btn btn-info btn-sm"
									@click="filtrarPortifolio()">
									<i class="fas fa-search mr-2"></i>
									Pesquisar
								</button>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>

		<div class="container mt-2">
			<div class="container mt-2">
				<card>
					<h4 slot="header" class="mb-0">Meu Portifólio</h4>

					<div id="accordionProjeto">

						<div class="col-12 btn btn-light text-left" data-toggle="collapse" data-target="#collapseProjeto" aria-expanded="true" aria-controls="collapseProjeto">
							<i class="far fa-calendar-check text-muted mr-2"></i>
							Projetos
						</div>
						
						<div class="collapse show font-13 col-12" id="collapseProjeto" data-parent="#accordionProjeto">
							<div class="row p-2" style="background-color: #f2f2f2">
								<div class="col-3 font-bold">Nome</div>
								<div class="col-2 font-bold">Período</div>
								<div class="col font-bold text-center">Criado por</div>
								<div class="col font-bold">Situação</div>
								<div class="col font-bold">Classificação</div>
							</div>
							<div><!-- v-for="projeto in listaProjeto" :key="projeto.idprojeto" -->
								<div class="row">
									<div class="col-3">Projeto de erradicação da CORONA</div>
									<div class="col-2 font-reagenda">21/06/1982 a 28/10/2021</div>
									<div class="col text-center">
										<img src="https://deidt-bucket.s3.sa-east-1.amazonaws.com/avatar_Marcos_7.png?version=1631067009379" 
											title="Marcos Osorio" width="30" class="rounded-circle mt-n1">
									</div>
									<div class="col">Concluído</div>
									<div class="col">Operacional</div>
								</div>

								<div id="accordionAtividade">

									<div class="col-12 btn btn-light text-left" data-toggle="collapse" data-target="#collapseAtividade" aria-expanded="false" aria-controls="collapseAtividade">
										<i class="fas fa-calendar-check text-muted mr-2"></i>
										Atividades
									</div>

									<div class="collapse show font-13 col-12" id="collapseAtividade" data-parent="#accordionAtividade">

										<div class="row p-2" style="background-color: #f2f2f2">
											<div class="col-3 font-bold">Nome</div>
											<div class="col-2 font-bold">Período</div>
											<div class="col font-bold text-center">Criado por</div>
											<div class="col font-bold">Situação</div>
										</div>
										<div> <!-- v-for="atividade in projeto.listaAtividades" :key="atividade.idatividade" -->
											<div class="row">
												<div class="col-3">Atividade de erradicação da CORONA</div>
												<div class="col-2">21/06/1982 a 28/06/2021</div>
												<div class="col text-center">
													<img src="https://deidt-bucket.s3.sa-east-1.amazonaws.com/avatar_Teste_54.png?version=1637472692464" 
														title="Marcos Osorio" width="30" class="rounded-circle mt-n1">
												</div>
												<div class="col">Concluído</div>
											</div>

											<div id="accordionTarefa">

												<div class="col-12 btn btn-light text-left" data-toggle="collapse" data-target="#collapseTarefa" aria-expanded="true" aria-controls="collapseTarefa">
													<i class="fas fa-tasks text-muted mr-2"></i>
													Tarefas
												</div>

												<div class="collapse show font-13 col-12" id="collapseTarefa" data-parent="#accordionTarefa">

													<div class="row p-2" style="background-color: #f2f2f2">
														<div class="col font-bold">Nome</div>
														<div class="col font-bold">Período</div>
														<div class="col font-bold">Situação</div>
													</div>
													<div> <!-- v-for="Tarefa in atividade.listaTarefas" :key="Tarefa.idTarefa" -->
														<div class="row">
															<div class="col">Tarefa de parar a CORONA</div>
															<div class="col">21/06/1982 a 28/06/2021</div>
															<div class="col">Concluído</div>
														</div>
													</div>
													<div> <!-- v-for="Tarefa in atividade.listaTarefas" :key="Tarefa.idTarefa" -->
														<div class="row">
															<div class="col">Tarefa 2 de parar a CORONA</div>
															<div class="col">21/06/1982 a 28/06/2021</div>
															<div class="col">Concluído</div>
														</div>
													</div>
													<div> <!-- v-for="Tarefa in atividade.listaTarefas" :key="Tarefa.idTarefa" -->
														<div class="row">
															<div class="col">Tarefa 3 de parar a CORONA</div>
															<div class="col">21/06/1982 a 28/06/2021</div>
															<div class="col">Concluído</div>
														</div>
													</div>

												</div>

											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</div>

		<modal :show.sync="modals.modalProjeto" size="xl">
			<Projeto v-if="modals.modalProjeto" 
				@atualizar-lista="filtrarPortifolio"
				:projetoSelecionado=projetoModal />
		</modal>
		<modal :show.sync="modals.modalAtividade" size="xl">
			<Atividade v-if="modals.modalAtividade" 
				@atualizar-lista="filtrarAtividade"
				:atividadeSelecionado=atividadeModal />
		</modal>

	</div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Projeto from "@/components/Projeto.vue";
import Atividade from "@/components/Atividade.vue";

export default {
	components: {
		Projeto,
		Atividade,
		flatPicker
	},
	created() {
		//this.carregarTela();
	},
	data() {
		return {
			progress: false,
			listaProjeto: [],
			listaProjetoFiltro: [],
			filtro: {
				ordem: 5,
			},
			projeto: {},
			modals: {
				modalProjeto: false,
				modalAtividade: false,
			},
			projetoModal: null,
			atividadeModal: null,
		};
	},
	methods: {
		filtrarPortifolio() {
			this.progress = true;
			this.$clubApi.post("/portifolio/lista", this.filtro).then((response) => {
				this.listaProjeto = response.data.object;
				this.listaProjetoFiltro = response.data.object;
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		abrirModalProjeto(projeto) {
			this.projetoModal = projeto;
			this.modals.modalProjeto = true;
		},
		abrirModalAtividade(atividade) {
			this.atividadeModal = atividade;
			this.modals.modalAtividade = true;
		},
		pesquisarPortifolio() {
			if (this.filtroTipo === "") {
				this.listaProjeto = this.listaProjetoFiltro;
			} else {
				this.listaProjeto = this.listaProjetoFiltro.filter((item) => {
					return (
						item.acao.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.funcionalidade.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.usuario.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						item.dataHoraFmt.indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
						(item.observacao != null && item.observacao.toUpperCase()
							.indexOf(this.filtroTipo.toUpperCase()) >= 0)
					);
				});
			}
		},
	}
}
</script>
<style>
.clickable {
	cursor: pointer;
}
.font-bold {
    font-weight: 600;
}
.font-reagenda {
    color: #b821bd !important;
    font-weight: 600;
}
.font-13 {
    font-size: 13px;
}
</style>
